<template>
    <!-- 查詢區 -->
    <el-form :model="searchForm" label-width="100px" label-position="top" class="search-form">
        <!-- 第一排 -->
        <el-row :gutter="20">
            <!-- 作業進度下拉 -->
            <el-col :span="4">
                <div style="padding: 0 20px;">
                    <el-form-item label="作業進度">
                        <el-select v-model="tableFrom.STATUS_CODE"
                                   multiple
                                   @change="handleStatusChange"
                                   placeholder="請選擇作業進度">

                            <el-option v-for="item in statusOptions"
                                       :key="item.value"
                                       :label="item.label"
                                       :value="item.value" />

                            <el-option v-for="item in baseStatusOptions"
                                       :key="item.STATUS_CODE"
                                       :label="item.STATUS_CODE + ' | ' + item.CHI_DESC"
                                       :value="item.STATUS_CODE" />
                        </el-select>
                    </el-form-item>
                </div>
            </el-col>

            <el-col :span="4">
                <el-form-item label="作業日期-起">
                    <el-date-picker v-model="searchForm.START_DATE"
                                    type="date"
                                    value-format="YYYY-MM-DD"
                                    style="width:100%">
                    </el-date-picker>
                </el-form-item>
            </el-col>

            <el-col :span="4">
                <el-form-item label="作業日期-止">
                    <el-date-picker v-model="searchForm.END_DATE"
                                    type="date"
                                    value-format="YYYY-MM-DD"
                                    style="width:100%">
                    </el-date-picker>
                </el-form-item>
            </el-col>

            <el-col :span="4">
                <div style="padding: 0 20px;">
                    <el-form-item label="託運單號">
                        <el-input v-model="searchForm.DLV_NO" />
                    </el-form-item>
                </div>
            </el-col>

            <el-col :span="4">
                <div style="padding: 0 20px;">
                    <el-form-item label="訂單編號">
                        <el-input v-model="searchForm.WORK_NO" />
                    </el-form-item>
                </div>
            </el-col>

            <el-col :span="4">
                <div style="padding: 0 20px;">
                    <el-form-item label="門店名稱/代號">
                        <el-input v-model="searchForm.DEPT_COMP_NAME" />
                    </el-form-item>
                </div>
            </el-col>
        </el-row>

        <!-- 第二排 -->
        <el-row :gutter="20" align="bottom">

            <!-- 品牌 -->
            <el-col :span="9" style="display:flex; justify-content:flex-start;">
                <div style="padding: 0 20px;">
                    <el-form-item label="品牌名稱" style="width:100%;">
                        <el-input v-model="searchForm.GOODS_OWNER_NAME" style="width: 215px;" />
                    </el-form-item>
                </div>
            </el-col>

            <!-- 按鈕 -->
            <el-col :span="6" style="display:flex; justify-content:center;">
                <div style="padding: 0 20px;">
                    <el-form-item label=" ">
                        <el-button type="primary" @click="onSearch" style="font-size:12px; padding:15px 120px;">Search</el-button>
                    </el-form-item>
                </div>
            </el-col>

            <!-- 地址 -->
            <el-col :span="9" style="display:flex; justify-content:flex-end;">
                <div style="padding: 0 20px;">
                    <el-form-item label="門店地址" style="width:100%;">
                        <el-input v-model="searchForm.DEPT_ADDR" style="width: 215px;" />
                    </el-form-item>
                </div>
            </el-col>

        </el-row>

        <!-- 快速查詢按鈕列 -->
        <el-row class="btn-bar" justify="center">
            <el-button v-for="btn in statusButtons"
                       :key="btn.code"
                       class="status-btn"
                       @click="quickSearch(btn.code)">
                {{ btn.label }} / {{ formatCount(statusCount[btn.code]) }}
            </el-button>
        </el-row>
    </el-form>

    <!-- Table -->
    <div ref="tableRef" style="margin-top:20px;"></div>

    <!-- 託運單貨態 -->
    <el-dialog title="[託運單貨態]" width="1200px" v-model="dialogStatusVisible" top="5vh"
               @opened="onDialogOpen('status')" center :lock-scroll="false" :close-on-click-modal="false">

        <el-row type="flex" justify="end">
            <!--<el-button type="primary" round plain @click="onAddClick()" v-show="store.getters.check_auth('ADD')">新增</el-button>-->
            <el-button type="primary" round plain @click="onStatusAdd">新增</el-button>
        </el-row>
        <div ref="tableStatusRef" style="margin-top:20px;"></div>

        <template #footer class="dialog-footer">
        </template>
    </el-dialog>

    <!-- 託運單明細 -->
    <el-dialog title="[託運單明細]"
               width="1400px"
               v-model="dialogDetailVisible"
               top="3vh"
               center
               :lock-scroll="false"
               :close-on-click-modal="false"
               @opened="onDetailOpened">

        <!-- 基本資料 -->
        <el-form :model="detailForm"
                 label-position="top">

            <el-row :gutter="12">

                <el-col :span="6">
                    <el-form-item label="託運代碼">
                        <el-input v-model="detailForm.DLV_SEQ"
                                  disabled
                                  style="width:70%;" />
                    </el-form-item>
                </el-col>

                <el-col :span="6">
                    <el-form-item label="託運單號">
                        <el-input v-model="detailForm.DLV_NO"
                                  disabled
                                  style="width:70%;" />
                    </el-form-item>
                </el-col>

                <el-col :span="6">
                    <el-form-item label="外送平台">
                        <el-input v-model="detailForm.TRN_LGS"
                                  disabled
                                  style="width:70%;" />
                    </el-form-item>
                </el-col>

                <el-col :span="6">
                    <el-form-item label="外送平台單號">
                        <el-input v-model="detailForm.TRN_ORDER_ID"
                                  disabled
                                  style="width:70%;" />
                    </el-form-item>
                </el-col>

            </el-row>

            <el-row :gutter="12">

                <el-col :span="12">
                    <el-form-item label="訂單編號">
                        <el-input v-model="detailForm.WORK_NO" disabled />
                    </el-form-item>
                </el-col>

                <el-col :span="3">
                    <el-form-item label="指定平台">
                        <el-input v-model="detailForm.DLV_PLATFORM" disabled />
                    </el-form-item>
                </el-col>

                <el-col :span="3">
                    <el-form-item label="司機數量">
                        <el-input v-model="detailForm.COURIER_NUM" :disabled="!isEditing || !store.getters.check_auth('MODIFY')" />
                    </el-form-item>
                </el-col>

                <el-col :span="3">
                    <el-form-item label="數量">
                        <el-input v-model="detailForm.QTY" :disabled="!isEditing || !store.getters.check_auth('MODIFY')" />
                    </el-form-item>
                </el-col>

                <el-col :span="3">
                    <el-form-item label="單位">
                        <el-input v-model="detailForm.QTY_UM" :disabled="!isEditing || !store.getters.check_auth('MODIFY')" />
                    </el-form-item>
                </el-col>

            </el-row>

            <el-row :gutter="12">

                <el-col :span="6">
                    <el-form-item label="取件日期">
                        <el-input :model-value="formatDateSlash(detailForm.DEPT_TIME)" :disabled="!isEditing || !store.getters.check_auth('MODIFY')" />
                    </el-form-item>
                </el-col>

                <el-col :span="3">
                    <el-form-item label="取件時段">
                        <el-input :model-value="formatTime(detailForm.DEPT_TIME_EST)" disabled />
                    </el-form-item>
                </el-col>

                <el-col :span="3">
                    <el-form-item label="取件時段">
                        <el-input :model-value="formatTime(detailForm.DEPT_PERIOD)" :disabled="!isEditing || !store.getters.check_auth('MODIFY')" />
                    </el-form-item>
                </el-col>

                <el-col :span="6">
                    <el-form-item label="門市取消時間">
                        <el-input :model-value="detailForm.CNL_TIME || ''" disabled />
                    </el-form-item>
                </el-col>

                <el-col :span="6">
                    <el-form-item label="代收款">
                        <el-input v-model="detailForm.COLLECT_AMT" :disabled="!isEditing || !store.getters.check_auth('MODIFY')" />
                    </el-form-item>
                </el-col>

            </el-row>

            <el-row :gutter="12">

                <el-col :span="6">
                    <el-form-item label="品牌名稱">
                        <el-input v-model="detailForm.GOODS_OWNER" disabled />
                    </el-form-item>
                </el-col>

                <el-col :span="6">
                    <el-form-item label="取件地名稱">
                        <el-input v-model="detailForm.DEPT_COMP_NAME" disabled />
                    </el-form-item>
                </el-col>

                <el-col :span="12">
                    <el-form-item label="收件人/公司">
                        <el-input v-model="detailForm.DEST_COMP_NAME" disabled />
                    </el-form-item>
                </el-col>

            </el-row>

            <el-row :gutter="12">

                <el-col :span="12">
                    <el-form-item label="電話">
                        <el-input v-model="detailForm.DEPT_TEL_NO" :disabled="!isEditing || !store.getters.check_auth('MODIFY')" />
                    </el-form-item>
                </el-col>

                <el-col :span="12">
                    <el-form-item label="電話">
                        <el-input v-model="detailForm.DEST_TEL_NO" :disabled="!isEditing || !store.getters.check_auth('MODIFY')" />
                    </el-form-item>
                </el-col>

            </el-row>

            <el-row :gutter="12">

                <el-col :span="12">
                    <el-form-item label="地址/取件">
                        <el-input v-model="detailForm.DEPT_ADDR" :disabled="!isEditing || !store.getters.check_auth('MODIFY')" />
                    </el-form-item>
                </el-col>

                <el-col :span="12">
                    <el-form-item label="地址/收件">
                        <el-input v-model="detailForm.DEST_ADDR" :disabled="!isEditing || !store.getters.check_auth('MODIFY')" />
                    </el-form-item>
                </el-col>

            </el-row>

            <el-row :gutter="12">

                <el-col :span="12">
                    <el-form-item label="取件注意事項">
                        <el-input type="textarea"
                                  :rows="4"
                                  v-model="detailForm.REMARKS_LOAD"
                                  :disabled="!isEditing || !store.getters.check_auth('MODIFY')" />
                    </el-form-item>
                </el-col>

                <el-col :span="12">
                    <el-form-item label="收件注意事項">
                        <el-input type="textarea"
                                  :rows="4"
                                  v-model="detailForm.REMARKS_UNLOAD"
                                  :disabled="!isEditing || !store.getters.check_auth('MODIFY')" />
                    </el-form-item>
                </el-col>

            </el-row>

            <el-row :gutter="12">
                <el-col :span="24" style="display:flex; justify-content:center; gap:10px;">

                    <!-- 貨品明細 -->
                    <el-button class="detail-btn"
                               @click="loadDetailItems">
                        貨品明細
                    </el-button>
                    <!-- 作業進度 -->
                    <el-button class="detail-btn"
                               style="margin-left:10px;"
                               @click="openStatusDialog">
                        作業進度
                    </el-button>
                    <!-- 確認修改 -->
                    <el-button class="detail-btn"
                               style="margin-left:10px;"
                               @click="enterEditMode">
                        修改
                    </el-button>
                    <!-- 存檔 -->
                    <el-button class="detail-btn"
                               @click="updateDetail"
                               :disabled="!isEditing">
                        存檔
                    </el-button>
                </el-col>
            </el-row>
            <el-dialog title="[貨品明細]"
                       v-model="dialogDetailItemsVisible"
                       width="1000px"
                       top="5vh"
                       center
                       :lock-scroll="false">

                <div ref="detailTableRef" style="margin-top:20px;"></div>

            </el-dialog>


        </el-form>

    </el-dialog>

    <el-dialog title="[轉單歷程]"
               width="900px"
               v-model="dialogTransVisible"
               top="5vh"
               center
               :close-on-click-modal="false">

        <el-form :model="detailForm"
                 label-position="top">

            <el-row :gutter="12">

                <el-col :span="4">
                    <el-form-item label="託運代碼">
                        <el-input v-model="detailForm.DLV_SEQ"
                                  disabled
                                  style="width:70%;" />
                    </el-form-item>
                </el-col>

                <el-col :span="6">
                    <el-form-item label="託運單號">
                        <el-input v-model="detailForm.DLV_NO"
                                  disabled
                                  style="width:70%;" />
                    </el-form-item>
                </el-col>

                <el-col :span="14">
                    <el-form-item label="訂單/出貨單號">
                        <el-input v-model="detailForm.WORK_NO"
                                  disabled
                                  style="width:70%;" />
                    </el-form-item>
                </el-col>

            </el-row>

        </el-form>

            <div ref="transTableRef" style="margin-top:20px;"></div>
            <el-card v-if="showContentPanel" style="margin-top:15px;">
                <div style="display:flex; justify-content:space-between; align-items:center;">
                    <b>內容明細</b>

                    <el-button size="small" @click="copyContent">
                        複製內容
                    </el-button>
                </div>

                <el-input type="textarea"
                          :rows="10"
                          v-model="selectedTransRow.ACTION_DATA"
                          readonly
                          style="margin-top:10px;" />
            </el-card>
</el-dialog>

    <!--新增/編輯貨態表單-->
    <el-dialog :title="`${stateStatus == 'add' ? '[新增]' : '[編輯]'}`" width="800px" v-model="dialogStatusFormVisible" top="5vh"
               @opened="onDialogOpen('statusForm')" center :lock-scroll="false" :close-on-click-modal="false">
        <el-form :model="statusForm" :rules="statusRules" ref="statusFormRef" :inline-message="true" label-position="top">
            <el-row>
                <el-col :span="12" style="padding: 0 6px;">
                    <el-form-item label="作業進度" prop="STATUS_CODE">
                        <el-select v-model="statusForm.STATUS_CODE" placeholder="請選擇作業進度" style="width: 100%">
                            <el-option v-for="item in baseStatusOptions"
                                       :key="item.STATUS_CODE"
                                       :value="item.STATUS_CODE"
                                       :label="`${item.STATUS_CODE} | ${item.CHI_DESC}`">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="6" style="padding: 0 6px;">
                    <el-form-item label="作業日期-起" prop="START_DATE">
                        <el-date-picker v-model="statusForm.START_DATE"
                                        type="date"
                                        placeholder="請選擇起始日期"
                                        value-format="YYYY-MM-DD"
                                        style="width: 100%">
                        </el-date-picker>
                    </el-form-item>
                </el-col>

                <el-col :span="6" style="padding: 0 6px;">
                    <el-form-item label="作業日期-止" prop="END_DATE">
                        <el-date-picker v-model="statusForm.END_DATE"
                                        type="date"
                                        placeholder="請選擇結束日期"
                                        value-format="YYYY-MM-DD"
                                        style="width: 100%">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="6" style="padding: 0 6px;">
                    <el-form-item label="時間" prop="TIME">
                        <el-time-picker v-model="statusForm.TIME"
                                        format="HH:mm"
                                        value-format="HH:mm"
                                        style="width: 100%">
                        </el-time-picker>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12" style="padding: 0 6px;">
                    <el-form-item label="作業地點" prop="EVENT_PLACE">
                        <el-input v-model="statusForm.EVENT_PLACE"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6" style="padding: 0 6px;">
                    <el-form-item label="溫度-1(°C)" prop="TMPR_1">
                        <el-input v-model="statusForm.TMPR_1"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6" style="padding: 0 6px;">
                    <el-form-item label="溫度-2(°C)" prop="TMPR_2">
                        <el-input v-model="statusForm.TMPR_2"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col style="padding: 0 6px;">
                    <el-form-item label="備註事項" prop="REMARKS">
                        <el-input type="textarea" v-model="statusForm.REMARKS" :rows="3"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6" style="padding: 0 6px;">
                    <el-form-item prop="FILE_TYPE">
                        <template #label>
                            <span style="padding-bottom: 2px; display: inline-block;">上傳照片/檔案</span>
                        </template>
                        <el-select v-model="statusForm.FILE_TYPE" placeholder="請選擇檔案類型" style="width: 100%">
                            <el-option v-for="item in fileTypeOptions"
                                       :key="item.value"
                                       :value="item.value"
                                       :label="item.label">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="6" style="padding: 0 6px;">
                    <el-form-item prop="FILE_NAME">
                        <template #label>
                            <el-upload ref="uploadRef"
                                       class="upload-btn-inline"
                                       action="#"
                                       :auto-upload="false"
                                       :limit="1"
                                       :show-file-list="false"
                                       :on-change="handleFileChange"
                                       :on-exceed="handleExceed">
                                <template #trigger>
                                    <el-button size="small" type="primary" plain style="margin-bottom: 0px;">
                                        選擇檔案
                                    </el-button>
                                </template>
                            </el-upload>
                        </template>

                        <el-input v-model="statusForm.FILE_NAME" placeholder="檔案名稱" disabled></el-input>
                    </el-form-item>
                </el-col>
                <el-col v-if="stateStatus === 'edit'" :span="3" style="padding: 0 6px;">
                    <el-text class="mx-1">修改人</el-text>
                </el-col>
                <el-col v-if="stateStatus === 'edit'" :span="9" style="padding: 0 6px;">
                    <el-row>
                        <el-col :span="24" :offset="3" style="padding: 0 6px;">
                            <el-text class="mx-1">{{ statusForm.EDIT_USER }}</el-text>
                        </el-col>
                        <el-col :span="24" :offset="3" style="padding: 0 6px;">
                            <el-text class="mx-1">{{ statusForm.EDIT_TIME }}</el-text>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
        </el-form>
        <template #footer class="dialog-footer">
            <el-button type="info" @click="dialogStatusFormVisible = false" style="width: 150px;">取消</el-button>
            <el-button type="primary" @click="onStatusSubmit" style="width: 150px;">存檔</el-button>
        </template>
    </el-dialog>
    <!-- 配達照片或簽收圖檔 -->
    <el-dialog title="[照片圖檔]" width="500px" v-model="dialogImgVisible" center label-width="" :lock-scroll="false" :close-on-click-modal="false">
        <el-row style="justify-content: center; align-items: center; padding: 10px;">
            <el-col :span="10" v-for="(item, index) in imgData" :key="index" style="margin-bottom: 20px; display: flex; flex-direction: column; align-items: center;">
                <div style="width: 100%; text-align: center;">
                    <el-image style="width: 160px; height: 160px; border-radius: 8px; border: 1px solid #dcdfe6;"
                              :src="getImageUrl(item.FILE_NAME)"
                              :preview-src-list="[getImageUrl(item.FILE_NAME)]"
                              fit="cover">
                        <template #error>
                            <div style="display: flex; justify-content: center; align-items: center; background: #f5f7fa; height: 160px; color: #909399;">
                                載入失敗
                            </div>
                        </template>
                    </el-image>

                    <div style="margin-top: 8px; text-align: center;">
                        <div style="font-weight: bold; color: #303133; font-size: 14px; line-height: 1.5;">
                            {{ item.CHI_DESC || '無描述' }}
                        </div>
                        <div style="color: #909399; font-size: 12px; line-height: 1.5;">
                            {{ formatDateTime(item.EDIT_TIME) }}
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>
    </el-dialog>

    <!--操作 選單-->
    <el-popover ref="actionPopover"
                v-model:visible="popoverVisible"
                placement="bottom-start"
                :virtual-ref="virtualRef"
                virtual-triggering>
        <div style="display: flex; flex-direction: column; align-items: flex-start;">
            <el-button text style="justify-content: flex-start; margin-left:12px" @click="handleAction('detail')">託運單明細</el-button>
            <el-button text style="justify-content: flex-start;" @click="handleAction('status')">託運單貨態</el-button>
            <el-button text style="justify-content: flex-start;" @click="handleAction('img')">照片圖檔</el-button>
            <el-button text style="justify-content: flex-start;" @click="handleAction('copy')">複製訂單</el-button>
            <el-button text style="justify-content: flex-start;" @click="handleAction('trans')">轉單歷程</el-button>
            <el-button text style="justify-content: flex-start;" @click="handleAction('transCancel')">取消轉單</el-button>
            <el-button text style="justify-content: flex-start;" @click="handleAction('delete')">取消託運單</el-button>
        </div>
    </el-popover>

</template>

<script setup>
    import { ref, reactive, onMounted, onUnmounted, nextTick, computed } from 'vue';
    import { TabulatorFull as Tabulator } from 'tabulator-tables';
    import { genFileId, ElMessageBox, ElMessage } from 'element-plus'
    import $api from '@/utils/axios';
    import { useStore } from 'vuex';

    const picUrl = ref(null); //圖片網址位置

    // Table 參考
    const tableRef = ref(null);
    const tableStatusRef = ref(null);
    let table = null;       // 主表
    let tableStatus = null; // 貨態表
    let statusTimer = null; // 貨態自動重新整理的計時器
    const statusCount = ref({});  // 貨態數量統計資料
    const uploadRef = ref(null); // 上傳檔案

    const popoverVisible = ref(false)   // 打開操作選單
    const virtualRef = ref(null)        // 操作選單：定位基準點
    const currentRow = ref(null)        // 表頭資料：目前選中資料
    const dialogStatusVisible = ref(false);     // 顯示 貨態列表 dialog
    const dialogStatusFormVisible = ref(false); // 顯示 貨態表單 dialog
    const dialogImgVisible = ref(false);        // 顯示 照片圖檔 dialog
    const stateStatus = ref('');                // 貨態表單 dialog：編輯模式「add」或「edit」
    const statusFormRef = ref(null);            // 貨態表單
    const imgData = ref(null);                  // 托運單圖檔

    const statusMap = ref({});  // 狀態 Map { STATUS_CODE: CHI_DESC }

    // 查詢表單
    const searchForm = reactive({
        START_DATE: '',
        END_DATE: '',
        STATUS_CODE: [],
        DLV_NO: '',
        WORK_NO: '',
        DEPT_COMP_NAME: '',
        GOODS_OWNER_NAME: '',
        DEPT_ADDR: ''
    });

    const dialogDetailItemsVisible = ref(false);

    // 託運單明細表單
    const detailForm = ref({
        DLV_SEQ:'',
        DLV_NO: '',
        WORK_NO: '',
        DEPT_TIME: '',
        DEPT_TIME_EST: '',
        DEPT_PERIOD: '',
        DLV_PLATFORM: '',
        CNL_TIME:'',
        COURIER_NUM: '',
        TRN_LGS: '',
        GOODS_OWNER: '',
        DEPT_COMP_NAME: '',
        DEPT_TEL_NO: '',
        DEPT_ADDR: '',
        TRN_ORDER_ID: '',
        DEST_COMP_NAME: '',
        DEST_TEL_NO: '',
        DEST_ADDR: '',
        QTY: '',
        QTY_UM: '',
        COLLECT_AMT: '',
        REMARKS_LOAD: '',
        REMARKS_UNLOAD: ''
    });

    const canEdit = computed(() => {
        return store.getters.check_auth('MODIFY');
    });

    // 貨態表單
    const statusForm = ref({
        DLV_SEQ: null,
        DLV_NO: '',
        STATUS_CODE: '',
        STATUS_NAME: '',
        START_DATE: '',
        END_DATE: '',
        EVENT_PLACE: '',
        REMARKS: '',
        TMPR_1: '', // 溫度 1
        TMPR_2: '', // 溫度 2
        IMG_FLAG: null, // 是否顯示附件按鍵
        FILE: null,
        FILE_TYPE: null,
        FILE_NAME: null,
        EDIT_USER: '',
        EDIT_TIME: '',
        DATE: null, // 作業日期
        TIME: null  // 作業時間
    });

    const dialogTransVisible = ref(false);
    const transTableRef = ref(null);
    let transTable = null;
    const selectedTransRow = ref(null);
    const showContentPanel = ref(false);

    const statusRules = reactive({
        STATUS_CODE: [{ required: true, message: '請選擇作業進度', trigger: 'blur' }],
        DATE: [{ required: true, message: '請選擇作業日期', trigger: 'blur' }],
        TIME: [{ required: true, message: '請選擇時間', trigger: 'blur' }],
    });

    const otherCodes = [
        'ST015', 'ST021', 'ST023', 'ST033',
        'ST034', 'ST037', 'ST032'
    ];

    const statusButtons = ref([
        { code: 'ST01', label: '成立託運單' },
        { code: 'ST02', label: '運輸公司接單' },
        { code: 'ST022', label: '司機接單' },
        { code: 'ST024', label: '取消轉單' },
        { code: 'ST025', label: '抵達取貨地' },
        { code: 'ST03', label: '取貨完成' },
        { code: 'ST035', label: '抵達卸貨地' },
        { code: 'ST04', label: '貨品送達' },
        { code: 'ST05', label: '取消託運單' },
        { code: 'OTHER', label: '其他' }
    ]);


    const quickSearch = (code) => {
        const today = formatDate(new Date());

        searchForm.START_DATE = today;
        searchForm.END_DATE = today;

        tableFrom.STATUS_CODE = [];

        if (code === 'OTHER') {
            tableFrom.STATUS_CODE = [
                'ST015', 'ST021', 'ST023', 'ST033',
                'ST034', 'ST037', 'ST032'
            ];
        } else {
            tableFrom.STATUS_CODE = [code];
        }

        onSearch();
    };

    // 下拉選單綁定
    const tableFrom = reactive({
        STATUS_CODE: [], // multiple 下拉必須是陣列
    });

    const fileTypeOptions = ref([]); // 檔案類型下拉
    const statusOptions = ref([
        { label: '全部查詢', value: 'ALL' },
        { label: '已完成不顯示', value: 'EXCLUDE_DONE' }
    ]);
    const baseStatusOptions = ref([]);  // 作業進度 下拉選項完整資料

    // 載入狀態 Map
    const loadStatusMap = async () => {
        try {
            const res = await $api.GET('/api/BaseStatus/GetStatusOptions', { withCredentials: true });

            const data = res.data ?? res; // ⭐兼容兩種格式

            const map = {};
            data.forEach(s => {
                map[s.STATUS_CODE] = s.CHI_DESC;
            });

            statusMap.value = map;
            baseStatusOptions.value = data;

        } catch (err) {
            console.error('載入狀態對照表失敗', err);
        }
    };

    const buildStatusPayload = () => {

        // 選到全部
        if (tableFrom.STATUS_CODE.includes('ALL')) {
            return null;
        }

        // 排除已完成
        if (tableFrom.STATUS_CODE.includes('EXCLUDE_DONE')) {
            return [
                'ST01', 'ST02', 'ST022', 'ST024', 'ST025',
                'ST03', 'ST035', 'ST015', 'ST021', 'ST023',
                'ST033', 'ST034', 'ST037', 'ST032'
            ];
        }

        // 一般選擇
        return [...tableFrom.STATUS_CODE];
    };

    // 點擊操作選單事件
    const handleAction = (type) => {
        console.log(type, currentRow.value)
        popoverVisible.value = false

        switch (type) {
            // 託運單貨態
            case 'status':
                dialogStatusVisible.value = true;
                break;
            // 託運單明細
            case 'detail':
                isEditing.value = false;
                detailForm.value = {
                    ...currentRow.value
                }
                currentDetailSeq.value = currentRow.value.DLV_SEQ
                dialogDetailVisible.value = true
                nextTick(() => {
                    initDetailTable()
                })
                break
            // 圖片
            case 'img':
                onImgClick(currentRow.value);
                break;
            // 轉單歷程
            case 'trans':
                openTransDialog(currentRow.value);
                break;

            default:
                break;
        }
    }

    const openTransDialog = async (row) => {
        if (!row) return;

        detailForm.value = {
            ...detailForm.value,
            DLV_SEQ: row.DLV_SEQ,
            DLV_NO: row.DLV_NO,
            WORK_NO: row.WORK_NO
        };

        dialogTransVisible.value = true;

        await nextTick();

        initTransTable();

        loadTransData(row);
    };

    const initTransTable = () => {
        if (transTable) return;

        transTable = new Tabulator(transTableRef.value, {
            layout: "fitColumns",
            height: "400px",
            placeholder: "無轉單歷程",


            columns: [
                { title: "Auto", field: "AUTO_FLAG" },
                { title: "Event Time", field: "ACTION_TIME" },
                { title: "Status", field: "STATUS" },
                { title: "in/out", field: "IN_OUT" },
                { title: "請求/回應", field: "TYPE" },
                { title: "Event", field: "ACTION" },
                { title: "Host IP", field: "ORIGINAL_IP" },
                { title: "呼叫端", field: "CALLER" },
                { title: "URL", field: "URL_PATH" },
                { title: "外送平台單號", field: "ORDER_ID" }
            ],
        });
        // 內容
        transTable.on("rowClick", (e, row) => {
            selectedTransRow.value = row.getData();
            showContentPanel.value = true;
        });
    };

    const copyContent = async () => {
        if (!selectedTransRow.value?.ACTION_DATA) return;

        try {
            await navigator.clipboard.writeText(selectedTransRow.value.ACTION_DATA);
            ElMessage.success('已複製內容');
        } catch (err) {
            ElMessage.error('複製失敗');
        }
    };

    const loadTransData = async (row) => {
        try {
            const res = await $api.GET('/api/DlvNote/GetLogList', {
                DLV_NO: row.DLV_NO,
                WORK_NO: row.WORK_NO
            });

            transTable.setData(res || []);
        } catch (err) {
            console.error('轉單歷程查詢失敗', err);
        }
    };

    const handleStatusChange = (val) => {

        // 如果選了 ALL
        if (val.includes('ALL')) {
            tableFrom.STATUS_CODE = ['ALL'];
            return;
        }

        // 如果選了 EXCLUDE_DONE
        if (val.includes('EXCLUDE_DONE')) {
            tableFrom.STATUS_CODE = ['EXCLUDE_DONE'];
            return;
        }

        // 如果選了其他，就把 ALL / EXCLUDE 移掉
        tableFrom.STATUS_CODE = val.filter(v => v !== 'ALL' && v !== 'EXCLUDE_DONE');
    };

    const handleFileChange = (uploadFile) => {
        statusForm.value.FILE_NAME = uploadFile.name

        statusForm.value.FILE = uploadFile.raw;
    }

    // 當選取超過限制數量時，自動覆蓋前一個檔案
    const handleExceed = (files) => {
        uploadRef.value.clearFiles();
        const file = files[0];
        file.uid = genFileId();
        uploadRef.value.handleStart(file);

        statusForm.value.FILE_NAME = file.name;
    };


    const getStatusSummary = async () => {
        const res = await $api.GET('/api/DlvNote/GetTodayStatusSummary');

        const map = {};
        let otherTotal = 0;

        res.forEach(item => {
            const code = item.STATUS_CODE;
            const count = item.CNT;

            map[code] = count;

            // 累加 OTHER
            if (otherCodes.includes(code)) {
                otherTotal += count;
            }
        });

        // 加入 OTHER
        map['OTHER'] = otherTotal;

        statusCount.value = map;
    };

    // 組裝圖片路徑
    const getImageUrl = (FILE_URL) => {
        console.log("path = ", picUrl.value + 'photos/' + FILE_URL);
        return picUrl.value + 'photos/' + FILE_URL;
    }

    const formatCount = (val) => {
        if (!val) return '00';
        return val.toString().padStart(2, '0');
    };

    const startAutoRefresh = () => {
        if (statusTimer) clearInterval(statusTimer);

        statusTimer = setInterval(() => {
            getStatusSummary();
        }, 30000); // 30秒
    };

    const stopAutoRefresh = () => {
        if (statusTimer) {
            clearInterval(statusTimer);
            statusTimer = null;
        }
    };

    const formatDateSlash = (val) => {
    if (!val) return '';
    const d = new Date(val);
    if (isNaN(d)) return val; // 已經是字串就直接回傳

    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');

    return `${yyyy}/${mm}/${dd}`;
    };

    const formatTime = (val) => {
    if (!val) return '';
    const d = new Date(val);
    if (isNaN(d)) return val;

    const hh = String(d.getHours()).padStart(2, '0');
    const mm = String(d.getMinutes()).padStart(2, '0');

    return `${hh}:${mm}`;
    };

    // 初始化 Table
    const initTable = () => {
        table = new Tabulator(tableRef.value, {
            layout: "fitColumns",
            height: "500px",
            columnDefaults: {
                headerHozAlign: "center"
            },
            placeholder: "無資料",
            pagination: "local",
            paginationSize: 100,
            paginationSizeSelector: [50, 100, 200],
            columns: [
                {
                    title: "NO",
                    formatter: "rownum",
                    width: 40,
                    hozAlign: "center",
                    frozen: true,
                    headerSort: false,
                },
                {
                    title: "操作",
                    width: 40,
                    hozAlign: "center",
                    headerSort: false,
                    formatter: () => {
                        return `<span style="
                            font-size:18px;
                            cursor:pointer;
                            display:inline-block;
                            line-height:1;
                        ">⚙️</span>`
                    },
                    cellClick: (e, cell) => {
                        currentRow.value = cell.getRow().getData()
                        const el = cell.getElement()
                        virtualRef.value = el   // ⭐定位 anchor
                        popoverVisible.value = true
                    }
                },
                {
                    title: "託運單號",
                    field: "DLV_NO",
                    hozAlign: "left",
                    width: 115,
                    headerSort: true
                },
                {
                    title: "訂單編號",
                    field: "WORK_NO",
                    hozAlign: "left",
                    width: 120,
                    headerSort: true,
                    formatter: (cell) => {
                        const val = cell.getValue();
                        if (!val) return "";

                        return val.replace(/(.{14})/g, "$1<br>");
                    },
                    formatterParams: {
                        sanitize: false
                    }
                },
                {
                    title: "品牌",
                    field: "GOODS_OWNER_NAME",
                    hozAlign: "left",
                    width: 100,
                    headerSort: false,
                    formatter: (cell) => {
                        const val = cell.getValue();
                        if (!val) return "";
                        const text = val.slice(0, 10);   // 取前10碼
                        return text.length < val.length ? text + "…" : text; // 多餘用省略號
                    },
                    cssClass: "wrap-text",  // 需在CSS加 wrap-word 才能換行
                },
                {
                    title: "門店名稱",
                    field: "DEPT_COMP_NAME",
                    hozAlign: "left",
                    width: 100,
                    headerSort: false,
                },
                {
                    title: "收件地址",
                    field: "DEST_ADDR",
                    hozAlign: "left",
                    width: 140,
                    headerSort: false,
                    formatter: (cell) => {
                        const val = cell.getValue();
                        if (!val) return "";

                        return val.replace(/(.{14})/g, "$1<br>");
                    },
                    formatterParams: {
                        sanitize: false
                    }
                },
                {
                    title: "作業日",
                    field: "DEPT_TIME",
                    hozAlign: "left",
                    headerSort: true,
                    formatter: (cell) => {
                        const val = cell.getValue();
                        if (!val) return "";
                        const date = new Date(val);
                        const yyyy = date.getFullYear();
                        const mm = String(date.getMonth() + 1).padStart(2, "0");
                        const dd = String(date.getDate()).padStart(2, "0");
                        return `${yyyy}/${mm}/${dd}`;
                    }
                },
                {
                    title: "取件時段",
                    field: "DEPT_PERIOD",
                    hozAlign: "left",
                    width: 90,
                    headerSort: true
                },
                {
                    title: "代收款",
                    field: "COLLECT_AMT",
                    hozAlign: "center",
                    width: 60,
                    headerSort: false,
                },
                {
                    title: "人數",
                    field: "COURIER_NUM",
                    hozAlign: "center",
                    width: 40,
                    headerSort: false,
                },
                {
                    title: "狀態",
                    field: "LAST_STATUS_CODE",
                    headerSort: false,
                    formatter: (cell) => {
                        const val = cell.getValue();
                        return val ? `${val}\n${statusMap.value[val] || ""}` : "";
                    }
                },
                {
                    title: "發生時間",
                    field: "LAST_STATUS_TIME",
                    formatter: (cell) => {
                        const val = cell.getValue();
                        if (!val) return "";
                        const date = new Date(val);
                        const mm = String(date.getMonth() + 1).padStart(2, "0");
                        const dd = String(date.getDate()).padStart(2, "0");
                        const hh = String(date.getHours()).padStart(2, "0");
                        const min = String(date.getMinutes()).padStart(2, "0");
                        const ss = String(date.getSeconds()).padStart(2, "0");
                        return `${mm}/${dd}\n${hh}:${min}:${ss}`;
                    },
                    hozAlign: "center",
                    headerSort: true
                },
                {
                    title: "指定平台",
                    field: "DLV_PLATFORM",
                    hozAlign: "left",
                    width: 40,
                    headerSort: false,
                },
                {
                    title: "轉單平台",
                    field: "TRN_LGS",
                    hozAlign: "left",
                    headerSort: false,
                },
                {
                    title: "司機",
                    field: "DRIVER_NAME",
                    hozAlign: "left",
                    headerSort: false,
                },
                {
                    title: "批價",
                    hozAlign: "left",
                    headerSort: false,
                    formatter: (cell) => {
                        const row = cell.getRow().getData();

                        const charge = row.CHARGE_AMT ?? "";
                        const payment = row.PAYMENT_AMT ?? "";

                        return `${charge} / ${payment}`;
                    }
                }
            ]
        });
    };

    // 初始化 託運單貨態 Table
    const initStatusTable = async () => {
        // 1. 如果已經初始化過，只需要更新資料並重繪
        if (tableStatus) {
            tableStatus.redraw(true);
            getStatusDataTable();
            return;
        }

        // 第一次開啟，進行初始化
        tableStatus = new Tabulator(tableStatusRef.value, {
            data: [], // 初始空資料
            layout: "fitColumns",
            height: "300px",
            columns: [
                { title: "作業代號", field: "STATUS_CODE", headerHozAlign: "center", hozAlign: "center" },
                { title: "作業進度", field: "STATUS_NAME", headerHozAlign: "center", hozAlign: "center", },
                {
                    title: "發生時間", field: "STATUS_TIME", headerHozAlign: "center", hozAlign: "center",
                    formatter: (cell) => {
                        const row = cell.getRow().getData();

                        const date = row.STATUS_TIME ? row.STATUS_TIME.split(' ')[0] : "";
                        const time = row.STATUS_TIME ? row.STATUS_TIME.split(' ')[1] : "";

                        return `${date}\n${time}`;
                    }
                },
                { title: "備註事項", field: "REMARKS", width: 350, headerHozAlign: "center", formatter: "textarea" },
                { title: "回報人", field: "EDIT_USER", headerHozAlign: "center", },
                {
                    title: "溫度", field: "TMPR", headerHozAlign: "center", hozAlign: "center",
                    formatter: (cell) => {
                        const row = cell.getRow().getData();

                        const tmpr1 = row.TMPR_1 ?? "";
                        const tmpr2 = row.TMPR_2 ?? "";

                        return `${tmpr1}\n${tmpr2}`;
                    }
                },
                {
                    title: "附件", field: "img", width: 50, headerHozAlign: "center", hozAlign: "center", headerSort: false,
                    formatter: (cell) => {
                        const row = cell.getRow().getData();
                        if (row.IMG_FLAG == true) {
                            return paperclipIcon(cell);
                        } else {
                            return '';
                        }
                    },
                    cellClick: (e, cell) => {
                        const row = cell.getData();
                        // 只有當有圖片標記時，才觸發點擊事件
                        if (row.IMG_FLAG == true) {
                            onImgClick(row, 'status');
                        }
                    }
                },
                { title: "修改", field: "edit", formatter: editIcon, width: 50, headerHozAlign: "center", hozAlign: "center", headerSort: false, cellClick: onStatusEdit },
                { title: "刪除", field: "delete", formatter: deleteIcon, width: 50, headerHozAlign: "center", hozAlign: "center", headerSort: false, cellClick: onStatusDelete },

            ],
        });

        // 3. 載入資料
        getStatusDataTable();
    };


    // 載入 Status Table 貨態表格
    const getStatusDataTable = async () => {
        try {
            const res = await $api.GET('/api/DlvNoteStatus/GetStatus', { DLV_SEQ: currentRow.value.DLV_SEQ });
            const fileTypeRes = await $api.GET('/api/SysSet/GetOptions', { CUST_CODE: currentRow.value.CUST_CODE, SET_ID: 'TMS_Upload_filetype' });
            tableStatus.setData(res);
            fileTypeOptions.value = fileTypeRes;
        } catch (err) {
            console.error('查詢失敗', err);
        }
    };

    const currentDetailSeq = ref(null);
    const detailTableRef = ref(null);
    let detailTable = null;
    const isEditing = ref(false);

    const store = useStore();

    const openStatusDialog = async () => {

        dialogStatusVisible.value = true;

    }

    const initDetailTable = () => {

        if (!detailTableRef.value) return;
        if (!detailTable) {
            detailTable = new Tabulator(detailTableRef.value, {
                layout: "fitColumns",
                height: "250px",
                placeholder: "請點查詢貨品明細",
                columns: [
                    {
                        title: "NO",
                        formatter: "rownum",
                        width: 40,
                        hozAlign: "center",
                        headerSort: false,
                    },
                    { title: "貨品編號", field: "GOODS_ID", headerSort: false, },
                    { title: "貨品名稱", field: "GOODS_DESC", headerSort: false, },
                    { title: "數量", field: "QTY", headerSort: false, },
                    { title: "單位", field: "QTY_UM", headerSort: false, },
                    { title: "金額", field: "AMT", headerSort: false, },
                    { title: "溫層", field: "TMP", headerSort: false, },
                    { title: "重量(KW)", field: "KW", headerSort: false, },
                    {
                        title: "刪除",
                        field: "delete",
                        formatter: (cell) => {
                            if (!store.getters.check_auth('DEL')) return '';
                            return deleteIcon(cell);
                        },
                        cellClick: (e, cell) => {
                            if (!store.getters.check_auth('DEL')) {
                                ElMessage.error('無刪除資料權限!!');
                                return;
                            }

                            onDetailItemDelete(cell.getRow().getData());
                        }
                    },
                ]
            });
        };
    };

    const enterEditMode = () => {

        if (!store.getters.check_auth('MODIFY')) {
            ElMessage.error('無修改資料權限!!');
            return;
        }

        isEditing.value = true;
    };

    const updateDetail = async () => {
        try {
            await $api.POST('/api/DlvNoteStatus/UpdateDlvNote', detailForm.value);

            ElMessage.success('修改成功');
            isEditing.value = false;
            dialogDetailVisible.value = false;

            await onSearch();
        } catch (err) {
            console.error(err);
            ElMessage.error('修改失敗');
        }
    };

    const showDetailTable = ref(false);

    const loadDetailItems = async () => {
        try {
            if (!currentDetailSeq.value) return;

            dialogDetailItemsVisible.value = true;

            await nextTick();

            if (!detailTable) {
                initDetailTable();
            }

            const res = await $api.GET('/api/DlvNoteStatus/GetDlvNoteItemsBySeq', {
                DLV_SEQ: currentDetailSeq.value
            });

            await nextTick();

            if (!detailTable) {
                console.warn('Tabulator 尚未初始化');
                return;
            }

            detailTable.setData(res ?? []);
        } catch (err) {
            console.error('loadDetailItems error:', err);
        }
    };
    const onDetailOpened = async () => {

        await nextTick();

        initDetailTable();

    }

    const dialogDetailVisible = ref(false)

    const getDlvNoteDetail = async (DLV_NO) => {

        try {

            const res = await $api.get('/DlvNote/GetDlvNote', {
                params: { DLV_NO }
            });

            if (res.data.length > 0) {

                detailForm.value = res.data[0];

                dialogDetailVisible.value = true;
            }

        } catch (err) {

            console.error(err);
        }
    };
    
    // 查詢 Table
    const onSearch = async () => {
        // 日期處理
        let startDate = "";
        let endDate = "";
        if (searchForm.DATE?.length) {
            startDate = formatDate(searchForm.DATE[0]);
            endDate = formatDate(searchForm.DATE[1]);
        }

        // 作業進度處理
        let lastStatusCodes = [];
        if (tableFrom.STATUS_CODE.includes("ALL")) {
            lastStatusCodes = []; // 全部顯示，API 不過濾
        } else if (tableFrom.STATUS_CODE.includes("EXCLUDE_COMPLETED")) {
            // 排除已完成 ST04, ST05
            lastStatusCodes = baseStatusOptions.value
                .map(s => s.STATUS_CODE)
                .filter(code => code !== "ST04" && code !== "ST05");
        } else {
            // 其他選項直接傳選中的狀態碼
            lastStatusCodes = [...tableFrom.STATUS_CODE];
        }

        // 組成 POST payload
        const payload = {
            START_DATE: searchForm.START_DATE || '',
            END_DATE: searchForm.END_DATE || '',
            LAST_STATUS_CODE: buildStatusPayload(),
            DLV_NO: searchForm.DLV_NO,
            WORK_NO: searchForm.WORK_NO,
            DEPT_COMP_NAME: searchForm.DEPT_COMP_NAME,
            GOODS_OWNER_NAME: searchForm.GOODS_OWNER_NAME,
            DEPT_ADDR: searchForm.DEPT_ADDR
        };

        try {
            // POST + JSON Body
            const res = await $api.POST('/api/DlvNote/GetTableDeliveryOrders', payload, {
                withCredentials: true
            });
            table.setData(res);
        } catch (err) {
            console.error('查詢失敗', err);
        }
    };

    const onStatusAdd = () => {
        stateStatus.value = 'add'
        dialogStatusFormVisible.value = true;
    }

    const onStatusEdit = (e, cell) => {
        stateStatus.value = 'edit';
        statusForm.value = JSON.parse(JSON.stringify(cell.getData()));
        if (statusForm.value.STATUS_TIME) {
            statusForm.value.DATE = statusForm.value.STATUS_TIME.split(' ')[0] || ''; // 取得日期部分
            statusForm.value.TIME = statusForm.value.STATUS_TIME.split(' ')[1] || ''; // 取得時間部分
        }
        console.log(statusForm.value);

        dialogStatusFormVisible.value = true;
    }
    const onStatusSubmit = async () => {
        if (!statusFormRef.value) return;

        // 1. 驗證表單規則 (Rule 檢查)
        await statusFormRef.value.validate(async (valid) => {
            if (!valid) return;

            try {
                const url = stateStatus.value === 'add'
                    ? '/api/DlvNoteStatus/Add'
                    : '/api/DlvNoteStatus/Edit';

                const formData = new FormData();

                Object.keys(statusForm.value).forEach(key => {
                    if (key === 'DATE' || key === 'TIME' || key === 'STATUS_TIME') return;
                    const value = statusForm.value[key];
                    if (value !== null && value !== undefined) {
                        formData.append(key, value);
                    }
                });

                if (statusForm.value.DATE) {
                    console.log(statusForm.value.DATE);
                    const fullTime = `${statusForm.value.DATE} ${statusForm.value.TIME || '00:00:00'}`;
                    formData.append('STATUS_TIME', fullTime);
                }

                const res = await $api.POST(url, formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                }).then((res) => {
                    if (res > 0) {
                        ElMessageBox.alert(`${stateStatus.value === 'add' ? '新增' : '編輯'}成功`, '提示', {
                            confirmButtonText: '確定',
                            callback: action => {
                                dialogStatusFormVisible.value = false;
                                getStatusDataTable();
                            }
                        });
                    } else {
                        ElMessageBox.alert(`${stateStatus.value === 'add' ? '新增' : '編輯'}失敗`, '提示', {
                            confirmButtonText: '確定'
                        });
                    }
                });

            } catch (error) {
                console.error('Submit Error:', error);
                ElMessage.error('儲存失敗，請檢查資料或連線');
            }
        });
    };

    const onDetailItemDelete = async (row) => {

        try {

            await ElMessageBox.confirm(
                '是否刪除此貨品明細?',
                '提示',
                {
                    confirmButtonText: '確認',
                    cancelButtonText: '取消',
                    type: 'warning',
                }
            );

            await $api.POST('/api/DlvNoteStatus/DeleteDetailItem', {
                DLV_SEQ: row.DLV_SEQ,
                ITEM_SEQ: row.ITEM_SEQ
            });

            ElMessage.success('刪除成功');

            loadDetailItems();

        } catch (err) {

            if (err !== 'cancel') {
                console.error(err);
                ElMessage.error('刪除失敗');
            }

        }
    };

    const onStatusDelete = (e, cell) => {
        ElMessageBox.confirm(
            `確定要刪除這筆貨態「${cell.getData().STATUS_NAME || cell.getData().STATUS_CODE}」及其相關照片嗎？`,
            '警告',
            {
                confirmButtonText: '確定刪除',
                cancelButtonText: '取消',
                type: 'warning',
                buttonSize: 'default',
            }
        ).then(() => {
            const param = {
                DLV_SEQ: cell.getData().DLV_SEQ,
                STATUS_CODE: cell.getData().STATUS_CODE,
                SEQ: cell.getData().SEQ,
            };

            $api.POST('/api/DlvNoteStatus/Delete', param)
                .then((res) => {
                    if (res > 1) {
                        ElMessageBox.alert('刪除成功', '提示', {
                            confirmButtonText: '確定',
                            callback: action => {
                                getStatusDataTable();
                            }
                        });
                    } else {
                        ElMessageBox.alert('刪除失敗', '提示', {
                            confirmButtonText: '確定'
                        });
                    }
                })
                .catch((err) => {
                    console.error('Delete Error:', err);
                    ElMessage.error('發生錯誤');
                });
        }).catch(() => {
            console.log('使用者取消刪除');
        });
    };

    const onImgClick = (data, type = '') => {
        try {
            console.log('data = ', data);
            const params = {
                START_DATE: searchForm.START_DATE,
                END_DATE: searchForm.END_DATE,
                DLV_SEQ: data.DLV_SEQ,
            };

            // 如果是從貨態表來的，或是資料裡剛好有 STATUS_CODE，就帶上它
            if (type === 'status') {
                params.STATUS_CODE = data.STATUS_CODE;
            }

            $api.GET('/api/DlvNoteImg/GetImages', params).then((response) => {
                imgData.value = response;
                dialogImgVisible.value = true;
            });
        } catch (err) {
            console.error('查詢圖片失敗', err);
        }
    }

    const onDialogOpen = (type) => {
        nextTick(() => {
            switch (type) {
                case 'status':
                    initStatusTable();
                    break;
                case 'statusForm':
                    console.log(stateStatus.value);
                    if (stateStatus.value === 'add') {
                        statusFormRef.value.resetFields();
                        statusForm.value.DLV_SEQ = currentRow.value.DLV_SEQ;
                        statusForm.value.DLV_NO = currentRow.value.DLV_NO;
                    }
                    break;
                default:
                    break;
            }
        })
    }

    // 日期格式化
    const formatDate = (date) => {
        const d = new Date(date);
        const yyyy = d.getFullYear();
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        const dd = String(d.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
    };
    const formatDateTime = (dateTime) => {
        if (!dateTime) return '---';
        const date = new Date(dateTime);
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, '0');
        const d = String(date.getDate()).padStart(2, '0');
        const hh = String(date.getHours()).padStart(2, '0');
        const mm = String(date.getMinutes()).padStart(2, '0');
        const ss = String(date.getSeconds()).padStart(2, '0');
        return `${m}/${d} ${hh}:${mm}:${ss}`;
    };

    const editIcon = (cell, formatterParams) => {
        return '<i class="el-icon"><svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path d="m199.04 672.64 193.984 112 224-387.968-193.92-112-224 388.032zm-23.872 60.16 32.896 148.288 144.896-45.696L175.168 732.8zM455.04 229.248l193.92 112 56.704-98.112-193.984-112-56.64 98.112zM104.32 708.8l384-665.024 304.768 175.936L409.152 884.8h.064l-248.448 78.336L104.32 708.8zm384 254.272v-64h448v64h-448z" fill="currentColor"></path></svg></i>';
    }

    const deleteIcon = (cell, formatterParams) => {
        return '<i class="el-icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" ><path fill="currentColor" d="M160 256H96a32 32 0 0 1 0-64h256V95.936a32 32 0 0 1 32-32h256a32 32 0 0 1 32 32V192h256a32 32 0 1 1 0 64h-64v672a32 32 0 0 1-32 32H192a32 32 0 0 1-32-32zm448-64v-64H416v64zM224 896h576V256H224zm192-128a32 32 0 0 1-32-32V416a32 32 0 0 1 64 0v320a32 32 0 0 1-32 32m192 0a32 32 0 0 1-32-32V416a32 32 0 0 1 64 0v320a32 32 0 0 1-32 32"></path></svg></i>';
    }

    const paperclipIcon = (cell, formatterParams) => {
        return '<i class="el-icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" ><path fill="currentColor" d="M602.496 240.448A192 192 0 1 1 874.048 512l-316.8 316.8A256 256 0 0 1 195.2 466.752L602.496 59.456l45.248 45.248L240.448 512A192 192 0 0 0 512 783.552l316.8-316.8a128 128 0 1 0-181.056-181.056L353.6 579.904a32 32 0 1 0 45.248 45.248l294.144-294.144 45.312 45.248L444.096 670.4a96 96 0 1 1-135.744-135.744z"></path></svg></i>';
    }

    // 初始化
    onMounted(async () => {
        // 取得圖片網址位置
        $api.GET('/api/Home/GetUrl', {
            url: "picUrl"
        }).then((res) => {
            picUrl.value = res;
        });

        await getStatusSummary();
        await loadStatusMap(); // 載入狀態 Map
        initTable();           // 初始化 Table
        startAutoRefresh();
    });

    onUnmounted(() => {
        stopAutoRefresh();
    });
</script>


<style scoped>
    :deep(.el-select .el-tag) {
        font-size: 12px;
    }

    .tabulator .tabulator-cell {
        white-space: normal !important;
        word-break: break-all;
        line-height: 1.4;
    }

    .status-bar {
        margin-top: 10px;
        flex-wrap: nowrap !important; /*強制同一行 */
        overflow-x: auto; /*避免擠爆*/
        gap: 6px;
    }

    .status-btn:hover {
        background-color: #e8f0ff !important;
        color: #0d5bdd !important;
        border-color: #8fbaff;
        box-shadow: 0 4px 10px rgba(0,0,0,0.12);
    }

    .status-btn {
        background-color: #f2f4f7 !important; /* 按鈕顏色 */
        color: #1e6fff !important; /* 字的顏色 */
        border: 1px solid transparent; /* 外框 */
        height: 28px; /*  縮小高度 */
        padding: 0 10px; /*  左右縮小 */
        font-size: 12px;
        border-radius: 6px;
        box-shadow: 0 2px 6px rgba(0,0,0,0.08); /* 陰影 */
        white-space: nowrap; /* 不換行 */
    }

    .detail-btn {
        background-color: #87CEFA !important; /* 天藍色 */
        border-color: #87CEFA !important;
        color: #000000 !important; /* 黑字 */
    }

        .detail-btn:hover,
        .detail-btn:focus,
        .detail-btn:active {
            background-color: #1E3A8A !important; /* 深藍色 */
            border-color: #1E3A8A !important;
            color: #FFFFFF !important; /* 白字 */
        }

        .detail-btn.is-active {
            background-color: #1E3A8A !important;
            border-color: #1E3A8A !important;
            color: #FFFFFF !important;
        }
</style>